module.exports = __webpack_public_path__ + "img/6.086851d6.png";